import * as React from 'react';
import { Button } from '@fluentui/react-components';
import { AddRegular } from '@fluentui/react-icons';
import { useApp } from './context';
import { Footer } from './Brand';
import type { Route } from './router';
import Home from '../pages/Home';
import Applications from '../pages/Applications';
import Clients from '../pages/Clients';
import Review from '../pages/Review';
import Library from '../pages/Library';
import History from '../pages/History';
import Settings from '../pages/Settings';

const NAV: { route: Route; label: string }[] = [
  { route: 'home', label: 'Today' },
  { route: 'applications', label: 'Applications' },
  { route: 'clients', label: 'Clients' },
  { route: 'library', label: 'Documents' },
  { route: 'history', label: 'History' },
  { route: 'settings', label: 'Settings' }
];

export function Shell(): React.ReactElement {
  const app = useApp();
  const waiting: number = app.queue.filter(q => q.status === 'waiting').length;

  const page: React.ReactElement = ({
    home: <Home />, applications: <Applications />, clients: <Clients />, review: <Review />, library: <Library />,
    history: <History />, settings: <Settings />
  } as { [r: string]: React.ReactElement })[app.route] ?? <Home />;

  return (
    <div className="shell">
      <nav className="sidebar" aria-label="Main">
        <div className="nav">
          {NAV.map(n => (
            <a key={n.route} href={`#/${n.route}`} aria-current={app.route === n.route ? 'page' : undefined}>
              {n.label}
            </a>
          ))}
          {/* Inbox filing is optional; its review queue only shows up when something waits. */}
          {waiting > 0 && (
            <a href="#/review" aria-current={app.route === 'review' ? 'page' : undefined}>
              Inbox review
              <span className="count-badge" aria-label={`${waiting} waiting`}>{waiting}</span>
            </a>
          )}
        </div>
        {app.workspace.firm?.listsReady && <Button as="a" href="#/applications/new" icon={<AddRegular />} style={{ width: '100%' }}>Open an application</Button>}
      </nav>
      <div className="content">
        {page}
        <Footer />
      </div>
    </div>
  );
}
